/**
 * Checks for horizontal overflow on an element.
 *
 * # Note
 * If the ref is null, it returns false */

export function checkOverflow<T extends HTMLElement>(
  ref: React.MutableRefObject<T | null>,
  direction: 'x' | 'y' | 'both' | 'either' = 'x',
): boolean {
  if (!ref.current) return false;
  const el = ref.current;
  if (direction === 'x') {
    return el.scrollWidth > el.clientWidth;
  }
  if (direction === 'y') {
    return el.scrollHeight > el.clientHeight;
  }
  if (direction === 'both') {
    return el.scrollWidth > el.clientWidth && el.scrollHeight > el.clientHeight;
  }
  return el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;
}
